import React, { useContext } from 'react';
import DataErrorPage from '../../../../../../Components/DataErrorPage/DataErrorPage';
import UrvalButton from '../../../../../../Components/Urval/Components/UrvalButton/UrvalButton';
import { IUIUrval } from '../../../../../../Types/UrvalTypes';
import { IClientBusinessModel } from '../../../../../../Types/ClientModelTypes';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import EDView from '../../../../../../BaseComponents/View/EDView';
import { RutinSettingsContext } from '../../RutinAvailabilityContext/RutinAvailabilityContext';
import EDIcon from '../../../../../../BaseComponents/Icon/EDIcon';
import EDFab from '../../../../../../BaseComponents/Fab/EDFab';
import EDTooltip from '../../../../../../BaseComponents/Tooltip/EDTooltip';
import EDAvenyProgress from '../../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import { ActiveRoutineContext } from '../../../../../Routing/ActiveRoutine/ActiveRoutineContext';

interface IProps {
  urval: IUIUrval | null;
  setUrval?: (newUrval: IUIUrval) => void;
  hasData: boolean;
  loading: boolean;
  refetch: () => void;
  collection: IClientBusinessModel;
  inCard?: boolean;
  notFullPage?: boolean;
}

// Visar en text om varför det inte finns några poster att visa i ett urval. Om det går att ändra urvalet så visas en knapp för att göra det.
export const EmptyReason: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { hasRutinStartError, setRutinStartErrorDialogOpen } =
    useContext(RutinSettingsContext);

  const activeRoutineContext = useContext(ActiveRoutineContext);
  let selection: React.ReactNode = '';
  let errorText = '';

  if (hasRutinStartError) {
    selection = 'Inställningar saknas';
  } else {
    if (props.loading) {
      errorText = `Hämtar ${props.collection.RootType.POLabel.toLowerCase()}`;
    } else if (props.urval == null) {
      selection = (
        <div>
          Ur<u>v</u>al
        </div>
      );
      errorText = `Gör ett urval för att välja vilka ${props.collection.RootType.POLabel.toLowerCase()} som visas (Alt+V)`;
    } else if (
      !props.hasData &&
      props?.collection.RootType.POLabel.toLowerCase() === 'dokument'
    ) {
      errorText = 'Inget dokument är bifogat';
    } else {
      errorText = `Det finns inga ${props.collection.RootType.POLabel.toLowerCase()} att visa ${
        props.urval.pages.length > 0 ? 'i det aktuella urvalet' : 'här'
      }`;
    }
  }

  return props.inCard ? (
    <EDView gutter>
      <EDTypography>
        {props.setUrval && (
          <UrvalButton
            urval={props.urval}
            setUrval={null}
            collectionName={props.collection.CollectionName}
            routineID={activeRoutineContext?.rutinInfo.rutinID}
            refetch={props.refetch}
          />
        )}
      </EDTypography>
      <EDTypography>{errorText}</EDTypography>
    </EDView>
  ) : (
    <DataErrorPage
      errorText={selection}
      iconNode={
        props.loading ? (
          <EDAvenyProgress />
        ) : hasRutinStartError ? (
          <EDTooltip title={'Öppna'} placement="right">
            <span>
              <EDFab
                boxShadowNone
                margin={1.25}
                size="large"
                onClick={() => {
                  setRutinStartErrorDialogOpen(true);
                }}
                color="error"
              >
                <EDIcon iconType="close" size="extraLarge" color="inherit" />
              </EDFab>
            </span>
          </EDTooltip>
        ) : props.setUrval ? (
          <span>
            <UrvalButton
              urval={props.urval}
              setUrval={props.setUrval}
              collectionName={props.collection.CollectionName}
              routineID={activeRoutineContext?.rutinInfo.rutinID}
              refetch={props.refetch}
              iconSize="large"
              iconColor="primary"
              fab
              errorText={errorText}
            />
          </span>
        ) : undefined
      }
      notFullPage={props.notFullPage && !props.setUrval}
    />
  );
};
